// extracted by mini-css-extract-plugin
export default {"about":"About_about__LJiOh","headline":"About_headline__EHFBy"};